import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
//import material ui
import {
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
  Paper,
  CardHeader,
  Typography,
  CardContent,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Divider,
  Tooltip,
  Pagination,
  TablePagination,
  Fab,
  Stack,
  CircularProgress,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Box,
  useTheme,
} from "@mui/material";

import FilterListIcon from "@mui/icons-material/FilterList";
import ArticleIcon from "@mui/icons-material/Article";
import AddIcon from "@mui/icons-material/Add";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";

//project components
import config from "../../../config";
import { setCandidateFilterData } from "../../../store/generalSlice";

//third party
import axios from "../../../api";
import useAxiosAuth from "../../../hooks/useAxiosAuth";

import CandidateFilterDlg from "./CandidateFilterDlg";

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress variant="determinate" {...props} color="secondary" />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
const getJobStatusText = (statusCode) => {
  switch (statusCode) {
    case 1:
      return "Working";
    case 2:
      return "Not Working";
    default:
      return statusCode ? statusCode.toString() : "--";
  }
};

const getExperienceText = (experienceCode) => {
  switch (experienceCode) {
    case 1:
      return "Fresher";
    case 2:
      return "Experienced";
    default:
      return experienceCode ? experienceCode.toString() : "--";
  }
};
const getRegistrationStatus = (registerCode) => {
  switch (registerCode) {
    case 1:
      return "Registered";
    case 2:
      return "Unregistered";
    default:
      return registerCode ? registerCode?.toString() : "--";
  }
};

const Candidates = () => {
  //Constanst
  const navigate = useNavigate();
  const axiosAuth = useAxiosAuth();
  const dispatch = useDispatch();
  const pageSize = 50;
  const { candidateFilterData } = useSelector((state) => state.generalReducer);
  const theme = useTheme();
  //States
  const [checked, setChecked] = useState(false);
  const [candidates, setCandidates] = useState();
  const [deletedCandidates, setDeletedCandidates] = useState();
  const [filterData, setFilterData] = useState({
    name: "",
    phoneNumber: "",
    location: "",
    gender: "",
    degreeName: "",
    minExperience: 0,
    maxExperience: 0,
    specialization: "",
    companyName: "",
    position: "",
    currentJobStatus: 0,
    registrationStatus: 0,
    skills: "",
    minSalary: 0,
    maxSalary: 0,
    isDeleted: false,
    isCandidateAvailable: true,
    amountDue: false,
    skip: 0,
    take: pageSize,
    filterApplied: false,
  });
  const [openFilterDlg, setOpenFilterDlg] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  console.log("condidates", candidateFilterData);
  //Services
  const getCandidates = (skip) => {
    let tempFilterData = {
      ...candidateFilterData,
      skip: skip,
      take: pageSize,
    };
    axiosAuth
      .post("/api/Candidates/list", tempFilterData)
      .then((response) => {
        setCandidates(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getDeletedCandidates = () => {
    axiosAuth
      .get("/api/Candidates/getDeleted-candidate")
      .then((response) => {
        setDeletedCandidates(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //UseEffects
  useEffect(() => {
    setCandidates(undefined);
    getCandidates();
  }, [candidateFilterData]);

  useEffect(() => {
    if (checked) {
      getDeletedCandidates();
    }
  }, [checked]);
  console.log("Profile", candidates?.candidates);
  return (
    <Grid
      container
      maxWidth="xl"
      sx={{ marginX: "auto", paddingY: 4, paddingX: 2 }}
    >
      <Card elevation={3} sx={{ width: "100%" }}>
        <Grid
          container
          sx={{
            background: "linear-gradient(to right,#4a7dcf 0%, #2a569f 100%)",
            paddingX: 2,
            paddingY: 1,
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h5" color="white.main">
              Candidates
            </Typography>
            <Grid>
              <Tooltip title="Apply filters">
                <IconButton
                  color="white"
                  onClick={() => {
                    setOpenFilterDlg(true);
                  }}
                >
                  <FilterListIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Add New">
                <IconButton
                  color="white"
                  sx={{ marginLeft: 2 }}
                  onClick={() => {
                    navigate("/admin/candidates/form");
                  }}
                >
                  <AddIcon sx={{ color: "white" }} />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            {candidateFilterData.filterApplied === true ? (
              <Card
                variant="outlined"
                sx={{
                  margin: 2,
                  padding: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Stack direction="row" spacing={2} alignItems="center">
                  <Typography
                    color="primary"
                    variant="h6"
                    sx={{ fontWeight: "600" }}
                  >
                    Filters Applied:
                  </Typography>
                  {candidateFilterData.name != "" ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Name: <b>{candidateFilterData.name}</b>
                    </Typography>
                  ) : null}
                  {candidateFilterData.location != "" ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Location: <b>{candidateFilterData.location}</b>
                    </Typography>
                  ) : null}
                  {candidateFilterData.phoneNumber != "" ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Phone No.: <b>{candidateFilterData.phoneNumber}</b>
                    </Typography>
                  ) : null}
                  {candidateFilterData.gender != "" ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Gender: <b>{candidateFilterData.gender}</b>
                    </Typography>
                  ) : null}
                  {candidateFilterData.degreeName != "" ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Degree: <b>{candidateFilterData.degreeName}</b>
                    </Typography>
                  ) : null}
                  {candidateFilterData.jobExperience > 0 ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Experience:{" "}
                      <b>
                        {getExperienceText(candidateFilterData.jobExperience)}
                      </b>
                    </Typography>
                  ) : null}
                  {candidateFilterData.specialization != "" ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Specialization:{" "}
                      <b>{candidateFilterData.specialization}</b>
                    </Typography>
                  ) : null}
                  {candidateFilterData.companyName != "" ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Company: <b>{candidateFilterData.companyName}</b>
                    </Typography>
                  ) : null}
                  {candidateFilterData.position != "" ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Position: <b>{candidateFilterData.position}</b>
                    </Typography>
                  ) : null}
                  {candidateFilterData.currentJobStatus != 0 ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Current Job Status:{" "}
                      <b>
                        {getJobStatusText(candidateFilterData.currentJobStatus)}
                      </b>
                    </Typography>
                  ) : null}
                  {candidateFilterData.registrationStatus > 0 ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Registration Status:{" "}
                      <b>
                        {getRegistrationStatus(
                          candidateFilterData.registrationStatus
                        )}
                      </b>
                    </Typography>
                  ) : null}
                  {candidateFilterData.skills != "" ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Skills: <b>{candidateFilterData.skills}</b>
                    </Typography>
                  ) : null}
                  {candidateFilterData.minExperience != 0 ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Min. Experience:{" "}
                      <b>{candidateFilterData.minExperience}</b>
                    </Typography>
                  ) : null}
                  {candidateFilterData.maxExperience != 0 ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Max. Experience:{" "}
                      <b>{candidateFilterData.maxExperience}</b>
                    </Typography>
                  ) : null}
                  {candidateFilterData.minSalary != 0 ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Min. Monthly Salary:{" "}
                      <b>{candidateFilterData.minSalary}</b>
                    </Typography>
                  ) : null}
                  {candidateFilterData.maxSalary != 0 ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Max. Monthly Salary:{" "}
                      <b>{candidateFilterData.maxSalary}</b>
                    </Typography>
                  ) : null}
                  {/* {candidateFilterData.isCandidateAvailable === true && (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Availability: <b>Available</b>
                    </Typography>
                  )} */}
                  {candidateFilterData.isCandidateAvailable === false && (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Availability: <b>Not Available</b>
                    </Typography>
                  )}
                  {candidateFilterData.isDeleted === true ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Only deleted
                    </Typography>
                  ) : null}
                  {/* {candidateFilterData.amountDue === true ? (
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      Amount Due
                    </Typography>
                  ) : null} */}
                </Stack>
                <Box>
                  <Tooltip title="Clear Filter">
                    <Fab
                      sx={{ marginLeft: 1, marginY: "auto" }}
                      color="primary"
                      size="small"
                      onClick={() => {
                        let tempFilterData = {
                          name: "",
                          phoneNumber: "",
                          location: "",
                          gender: "",
                          degreeName: "",
                          jobExperience: 0,
                          currentJobStatus: 0,
                          candidateSpecializationMasterId: null,
                          specialization: "",
                          companyName: "",
                          position: "",
                          registrationStatus: 0,
                          skills: "",
                          minExperience: 0,
                          maxExperience: 0,
                          minSalary: 0,
                          maxSalary: 0,
                          isDeleted: false,
                          isCandidateAvailable: true,
                          amountDue: false,
                          skip: 0,
                          take: pageSize,
                          filterApplied: false,
                        };
                        dispatch(setCandidateFilterData(tempFilterData));
                      }}
                    >
                      <FilterListOffIcon />
                    </Fab>
                  </Tooltip>
                </Box>
              </Card>
            ) : null}
          </Grid>
          <Grid item xs={12}>
            {candidates != undefined ? (
              <Box sx={{ padding: 1, marginTop: 1 }}>
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={2}
                  justifyContent="end"
                >
                  <Typography>Total: {candidates.count}</Typography>
                  <Pagination
                    count={Math.ceil(candidates.count / pageSize)}
                    variant="outlined"
                    shape="rounded"
                    showFirstButton
                    showLastButton
                    color="primary"
                    sx={{ marginTop: 2 }}
                    onChange={(event, page) => {
                      getCandidates((page - 1) * pageSize);
                    }}
                  />
                </Stack>
              </Box>
            ) : null}
          </Grid>

          <Grid item xs={12}>
            {candidates != undefined &&
            candidates.candidates?.length > 0 &&
            checked != true ? (
              <Box>
                <Box
                  sx={{
                    display: { xs: "flex", md: "none" },
                    flexDirection: "column",
                  }}
                >
                  {candidates.candidates?.map((candidate, index) => {
                    return (
                      <Card
                        key={index}
                        variant="outlined"
                        sx={{
                          margin: 1,
                          padding: 1,
                          display: "flex",
                          justifyContent: "space-between",
                          backgroundColor: "#F5F5F5",
                        }}
                      >
                        <Stack spacing={1}>
                          <Typography
                            sx={{
                              color:
                                candidateFilterData.isDeleted === true
                                  ? theme.palette.error.main
                                  : "inherit",
                            }}
                          >
                            <b>Name - (Mobile):</b> {candidate.salutation}{" "}
                            {candidate.firstName} {candidate.middleName}{" "}
                            {candidate.lastName} - ({candidate.phoneNumber})
                          </Typography>
                          <Typography>
                            <b>Highest Qualification:</b>{" "}
                            {candidate.highestQualification}
                          </Typography>
                          <Typography>
                            <b>Specialization:</b> {candidate.specialization}
                          </Typography>
                          <Typography>
                            <b>Gender:</b> {candidate.gender}
                          </Typography>
                          <Typography>
                            <b>Marrital Status:</b> {candidate.marritalStatus}
                          </Typography>
                          <Typography>
                            <b>Skills:</b> {candidate.skills}
                          </Typography>
                          <Typography>
                            <b>Location:</b> {candidate.city}
                          </Typography>
                          {/* <Typography>
                            <b>Amount Due:</b> {candidate.amountDue?.toFixed(2)}
                          </Typography> */}
                          {/* <Stack
                            direction="row"
                            spacing={2}
                            alignItems="center"
                          >
                            <Typography>
                              <b>Profile:</b>
                            </Typography>
                            <CircularProgressWithLabel
                              value={candidate.profilePercentage}
                            />
                          </Stack> */}
                        </Stack>
                        <Stack
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Tooltip title="View Details">
                            <IconButton
                              variant="outlined"
                              color="primary"
                              onClick={() => {
                                navigate("/profile?ref=" + candidate.id);
                              }}
                            >
                              <ArticleIcon fontSize="inherit" />
                            </IconButton>
                          </Tooltip>
                          {/* <Typography>{candidate.index}</Typography> */}
                        </Stack>
                      </Card>
                    );
                  })}
                </Box>
                <Box sx={{ display: { xs: "none", md: "flex" } }}>
                  <TableContainer sx={{ padding: 2 }}>
                    <Table
                      size="small"
                      sx={{
                        borderWidth: 1,
                        border: "solid",
                        borderColor: "#f2f2f2",
                      }}
                    >
                      <TableHead>
                        <TableRow sx={{ backgroundColor: "#e6eeff" }}>
                          <TableCell sx={{ width: 50 }}>#</TableCell>
                          <TableCell align="left">Name - (Mobile)</TableCell>
                          <TableCell align="left" sx={{ width: 160 }}>
                            Highest Qualification
                          </TableCell>
                          <TableCell align="left" sx={{ width: 180 }}>
                            Specialization
                          </TableCell>
                          <TableCell align="left" sx={{ width: 150 }}>
                            Location
                          </TableCell>
                          {/* <TableCell align="left" sx={{ width: 120 }}>
                            Amount Due
                          </TableCell> */}

                          <TableCell
                            align="right"
                            sx={{ width: 60 }}
                          ></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {candidates.candidates?.map((row, index) => (
                          <TableRow key={row.id}>
                            <TableCell component="th" scope="row">
                              {row.index}
                            </TableCell>
                            <TableCell align="left">
                              <Typography
                                variant="h6"
                                sx={{
                                  color:
                                    candidateFilterData.isDeleted === true
                                      ? theme.palette.error.main
                                      : "inherit",
                                }}
                              >
                                {row.salutation}
                                {row.firstName} {row.middleName} {row.lastName}
                              </Typography>
                              <Typography variant="caption">
                                {row.phoneNumber}
                              </Typography>
                              <br />
                              <Typography variant="caption">
                                {row.gender},{row.marritalStatus}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              {row.highestQualification
                                ? row.highestQualification
                                : "--"}
                            </TableCell>
                            <TableCell align="left">
                              <Typography>
                                {row.specialization ? row.specialization : "--"}
                              </Typography>
                              <Typography variant="caption">
                                {row.skills ? row.skills : "--"}
                              </Typography>
                            </TableCell>

                            <TableCell align="left">
                              <Typography variant="body2">
                                District: {row.district ? row.district : "--"}
                              </Typography>
                              <Typography variant="body2">
                                Taluka: {row.taluka ? row.taluka : "--"}
                              </Typography>
                              <Typography variant="body2">
                                City: {row.city ? row.city : "--"}
                              </Typography>
                            </TableCell>

                            {/* <TableCell align="left">
                              <Typography
                                variant="h6"
                                fontWeight="bold"
                                color="error"
                              >
                                {row.amountDue
                                  ? row.amountDue?.toFixed(2)
                                  : "--"}
                              </Typography>
                            </TableCell> */}
                            <TableCell align="right">
                              <Tooltip title="View Details">
                                <IconButton
                                  variant="outlined"
                                  color="primary"
                                  size="small"
                                  onClick={() => {
                                    navigate("/profile?ref=" + row.id);
                                  }}
                                >
                                  <ArticleIcon fontSize="inherit" />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            ) : candidates == undefined && checked != true ? (
              <Box
                sx={{ display: "flex", justifyContent: "center", marginY: 5 }}
              >
                <Stack
                  direction="column"
                  spacing={3}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Typography variant="h5" textAlign="center">
                    Loading Candidates...
                  </Typography>
                  <CircularProgress />
                </Stack>
              </Box>
            ) : candidates?.candidates?.length === 0 && checked != true ? (
              <Box
                sx={{ display: "flex", justifyContent: "center", marginY: 5 }}
              >
                <Typography variant="h5" textAlign="center">
                  No candidates found matching your criteria
                </Typography>
              </Box>
            ) : checked == true ? (
              //------------------------SHOW DELETED CANDIDATES-----------------------//

              <Box>
                <Box
                  sx={{
                    display: { xs: "flex", md: "none" },
                    flexDirection: "column",
                  }}
                >
                  {deletedCandidates?.map((candidate, index) => {
                    return (
                      <Card
                        key={index}
                        variant="outlined"
                        sx={{
                          margin: 1,
                          padding: 1,
                          display: "flex",
                          justifyContent: "space-between",
                          backgroundColor: "#F5F5F5",
                        }}
                      >
                        <Stack spacing={1}>
                          <Typography>
                            <b>Name:</b> {candidate.salutation}
                            {candidate.firstName} {candidate.middleName}{" "}
                            {candidate.lastName}
                          </Typography>
                          <Typography>
                            <b>Email:</b> {candidate.email}
                          </Typography>
                          <Typography>
                            <b>Phone No.:</b> {candidate.phoneNumber}
                          </Typography>
                          <Typography>
                            <b>City:</b> {candidate.city}
                          </Typography>
                        </Stack>
                        <Stack
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Tooltip title="View Details">
                            <IconButton
                              variant="outlined"
                              color="primary"
                              size="small"
                              onClick={() => {
                                navigate("/profile?ref=" + candidate.id);
                              }}
                            >
                              <ArticleIcon fontSize="inherit" />
                            </IconButton>
                          </Tooltip>
                          <Typography>{index + 1}</Typography>
                        </Stack>
                      </Card>
                    );
                  })}
                </Box>
                <Box sx={{ display: { xs: "none", md: "flex" } }}>
                  <TableContainer sx={{ padding: 2 }}>
                    <Table
                      sx={{
                        borderWidth: 1,
                        border: "solid",
                        borderColor: "#f2f2f2",
                      }}
                    >
                      <TableHead>
                        <TableRow sx={{ backgroundColor: "#e6eeff" }}>
                          <TableCell>Sr. No.</TableCell>
                          <TableCell align="left">Name</TableCell>
                          <TableCell align="left">Email</TableCell>
                          <TableCell align="left">Phone No.</TableCell>
                          <TableCell align="left">City</TableCell>
                          <TableCell align="right"></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {deletedCandidates?.map((row, index) => (
                          <TableRow key={row.id}>
                            <TableCell component="th" scope="row">
                              {index + 1}
                            </TableCell>
                            <TableCell align="left">
                              {row.salutation}
                              {row.firstName} {row.middleName} {row.lastName}
                            </TableCell>
                            <TableCell align="left">{row.email}</TableCell>
                            <TableCell align="left">
                              {row.phoneNumber}
                            </TableCell>
                            <TableCell align="left">{row.city}</TableCell>
                            <TableCell align="right">
                              <Tooltip title="View Details">
                                <IconButton
                                  variant="outlined"
                                  color="primary"
                                  size="small"
                                  onClick={() => {
                                    navigate("/profile?id=" + row.id);
                                  }}
                                >
                                  <ArticleIcon fontSize="inherit" />
                                </IconButton>
                              </Tooltip>
                              {/*<IconButton color="error" size="small" onClick={() => {}}>
                      <DeleteIcon fontSize="inherit" />
                    </IconButton> */}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            ) : null}
          </Grid>
          <Grid item xs={12}>
            {candidates != undefined ? (
              <Box
                sx={{
                  paddingX: 2,
                  marginBottom: 2,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Pagination
                  count={Math.ceil(candidates.count / pageSize)}
                  variant="outlined"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                  color="primary"
                  onChange={(event, page) => {
                    getCandidates((page - 1) * pageSize);
                  }}
                />
              </Box>
            ) : null}
          </Grid>
        </Grid>
      </Card>
      <Dialog
        fullWidth
        maxWidth="md"
        open={openFilterDlg}
        onClose={() => {
          setOpenFilterDlg(false);
        }}
      >
        <DialogContent>
          <CandidateFilterDlg
            filterData={candidateFilterData}
            onCancel={() => {
              setOpenFilterDlg(false);
            }}
            onSave={(values) => {
              dispatch(setCandidateFilterData(values));
              //setFilterData(values);
              setOpenFilterDlg(false);
            }}
          />
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default Candidates;
